import { useEffect, useState } from "react";
import moment from "moment";

import { Page, Container } from "@/ui/Layout/Page";
import { Grid } from "@/ui/Grid";
import { Card } from "@/ui/Card";
import { getCampaigns } from "@/api/campaigns";
import { ButtonTypes, Status } from "@/ui/types";
import { getSessionToken } from "@/api/auth";
import { Link } from "react-router-dom";
import Button from "@/ui/Button";
import { EmptyState } from "@/ui/Layout";
import { Loading } from "@/ui/Layout/Loading";

import { LAUNCH_OS_ICON } from "@/brand";
export const Blogs = ({ name = "" }) => {
  const [blogList, setBlogList] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // get the blogList from the server
  const loadBlogs = async () => {
    const token = getSessionToken();
    const response = await getCampaigns({ token, type: "blog" });
    // const response = await getCampaigns({ token, type: "blog" });
    if (response) {
      // convert the response to the format that the Card components expect
      const seqs = response
        ?.filter(({ deleted }) => !deleted)
        .map((blog: any) => {
          return {
            id: blog.id,
            label: blog.name,
            caption: `Last Updated: ${moment(blog.updatedAt).fromNow()}`,
            img: (
              <img
                className="w-[42px] h-[42px] flex-none rounded-full overflow-hidden object-cover"
                src={LAUNCH_OS_ICON}
                alt=""
              />
            ), // funnel.screensnhot
            status: Status.INPROGRESS,
          };
        });

      setBlogList(seqs);
    }
    setIsLoading(false);
  };

  // load the blogList when the page loads
  useEffect(() => {
    loadBlogs();
  }, []);

  return (
    <Page
      topBar={{
        page: [{ label: name }],
        items: (
          <Link to="/launchpad/blogs" className="justify-end">
            <Button label="+ Create a Blog" type={ButtonTypes.OUTLINED} />
          </Link>
        ),
      }}
    >
      <Container>
        {isLoading && <Loading type="gallery" />}
        {!isLoading && !Boolean(blogList.length) && (
          <EmptyState
            title="No Blogs Yet"
            description="Get started by creating a new blog."
            showImage={false}
          >
            <Link to="/launchpad/blogs">
              <Button label="Create a Blog" type={ButtonTypes.DEFAULT} />
            </Link>
          </EmptyState>
        )}
        {!isLoading && Boolean(blogList.length) && (
           <Grid className="pb-6">
            {/* Can we change to Gallery View - let's me toggle views */}
            {blogList.map(
              (
                {
                  id,
                  label,
                  caption,
                  img = "[logo]",
                  status,
                  // sharedWith,
                  taskDetails,
                },
                key
              ) => {
                return (
                  <Card
                    key={key}
                    label={label}
                    caption={caption}
                    image={img}
                    href={`/blogs/${id}`}
                    status={status}
                    taskDetails={taskDetails}
                  />
                );
              }
            )}
          </Grid>
        )}
      </Container>
    </Page>
  );
};
